import React from 'react';
import { Image } from 'antd';
import { ImageProps } from 'antd';

interface CustomImageProps extends Omit<ImageProps, 'width' | 'height'> {
  src?: string;
  width?: string | number;
  height?: string | number;
  alt?: string;
  preview?: boolean;
  style?: React.CSSProperties;
}

const CustomImage: React.FC<CustomImageProps> = ({
  src,
  width,
  height,
  alt,
  preview,
  style,
  ...props
}) => {
  return (
    <Image
      width={width}
      height={height}
      src={src}
      alt={alt}
      preview={preview}
      style={style}
      {...props}
    />
  );
};

export default CustomImage;
